<template>
    <component :is="componentIs">
        <slot
            v-bind="{
                icon,
                button,
                message,
                disabled,
            }"
        />
    </component>
</template>

<script>
import { mapState } from "vuex";
import { initInterview } from "@/assets/variables";

export default {
    props: {
        componentIs: { type: String, default: "div" },
    },
    computed: {
        ...mapState({ _user: (store) => store.payload?._user }),
        ...mapState("interview", { interview: (store) => store.data }),
        isUserParticipant() {
            return this.interview._participants.includes(this._user);
        },
        disabled() {
            return this.interview.entrance.disabled;
        },
        icon() {
            return "mdi-login-variant";
        },
        button() {
            if (this.isUserParticipant) return "지금 참여하기";
            else return "참여 요청하기";
        },
        message() {
            let { message } = this.interview.entrance.meta;
            if (message) return message;

            if (this.isUserParticipant) return "지금 참여하시겠습니까?";
            else return "참여요청이 필요합니다";
        },
    },
};
</script>

<style>
</style>